import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import { EVENT_NAMES as MobileMenuEvents } from '@Front/modules/navigation/components/navigationHeader/events';
import { selectors, settings, TOOLTIP_DELAY } from './config';
import { EVENT_NAMES } from './events';
import Tooltip from './Tooltip';
import Trigger from './Trigger';
import KenectObserver from '../shared/KenectObserver';

export default class TextFeatureController extends Component {
  static selector = '[data-comp-kenect-text-controller]';

  tooltip;
  tooltipContainer;
  trigger;
  triggerContainer;
  widgetId;

  initialized = false;

  constructor(containerEl) {
    super(containerEl);

    this.widgetId = containerEl.dataset.widgetId;
    this.triggerContainer = containerEl.querySelector(
      selectors.trigger.container,
    );
    this.tooltipContainer = containerEl.querySelector(
      selectors.tooltip.container,
    );

    this.kenectObserver = new KenectObserver(document.body);
    this.trigger = new Trigger(this.triggerContainer);
    this.tooltip = new Tooltip(this.tooltipContainer);

    this.mount();
  }

  relocateKenectWidget() {
    this.kenectContainer.remove();
    this.$container.appendChild(this.kenectContainer);
  }

  showKenectWidget() {
    this.kenectContainer.ariaHidden = false;
  }

  hideKenectWidget() {
    this.kenectContainer.ariaHidden = true;
  }

  updateTooltipText() {
    if (this.tooltip.isClosed()) return;

    const { innerWidth } = window;
    const tooltipText = innerWidth >= breakpoints['break-2']
      ? settings.tooltipText.desktop
      : settings.tooltipText.mobile;

    this.tooltip.setText(tooltipText);
  }

  attachListeners() {
    window
      .matchMedia(`(min-width: ${breakpoints['break-2']}px)`)
      .addEventListener('change', () => this.updateTooltipText());

    window.addEventListener(MobileMenuEvents.OPEN, () => {
      if (!this.initialized) return;

      this.trigger.close();
    });

    this.kenectObserver.observe(document.body, (currentMutation) => {
      const isKenectComponent = currentMutation.target.id.includes(
        this.widgetId,
      );

      if (!isKenectComponent || this.initialized) return;

      const kenectContainerSelector = `iframe-${this.widgetId}`;
      const kenectContainer = document.getElementById(kenectContainerSelector);
      const kenectButtonSelector = `button.reset-${this.widgetId}`;
      const kenectButton = document.querySelector(kenectButtonSelector);

      this.initialize(kenectContainer, kenectButton);
      this.kenectObserver.disconnect();
    });

    this.trigger.on(EVENT_NAMES.OPENED, () => {
      this.tooltip.disable();
      this.showKenectWidget();
    });

    this.trigger.on(EVENT_NAMES.CLOSED, () => {
      this.hideKenectWidget();
    });
  }

  initialize(kenectContainerEl, kenectButtonEl) {
    this.kenectContainer = kenectContainerEl;
    this.relocateKenectWidget();
    this.trigger.setKenectButton(kenectButtonEl);
    this.trigger.enable();
    this.initialized = true;

    setTimeout(() => {
      this.updateTooltipText();
      this.tooltip.show();
    }, TOOLTIP_DELAY);
  }

  mount() {
    this.attachListeners();
  }
}
